"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryLegend", {
  enumerable: true,
  get: function () {
    return _victoryLegend.default;
  }
});

var _victoryLegend = _interopRequireDefault(require("./victory-legend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-legend/lib/index.js
// module id = 1887
// module chunks = 0